/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ScriptsRouteImport } from './routes/scripts'
import { Route as ReviewQueueRouteImport } from './routes/review-queue'
import { Route as RecordsRouteImport } from './routes/records'
import { Route as PromptBuilderRouteImport } from './routes/prompt-builder'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as LinkPortalRouteImport } from './routes/link-portal'
import { Route as KnowledgeBaseRouteImport } from './routes/knowledge-base'
import { Route as EmbeddedRouteImport } from './routes/embedded'
import { Route as DemosRouteImport } from './routes/demos'
import { Route as DealsRouteImport } from './routes/deals'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CompetitionsRouteImport } from './routes/competitions'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as AssistantRouteImport } from './routes/assistant'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as AnalysisSetupRouteImport } from './routes/analysis-setup'
import { Route as AnalysesRouteImport } from './routes/analyses'
import { Route as AlertsRouteImport } from './routes/alerts'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as DemosIndexRouteImport } from './routes/demos/index'
import { Route as CoachingIndexRouteImport } from './routes/coaching/index'
import { Route as AnalyticsIndexRouteImport } from './routes/analytics/index'
import { Route as AnalysisSetupIndexRouteImport } from './routes/analysis-setup.index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as ProjectsNewRouteImport } from './routes/projects.new'
import { Route as InvitationsTokenRouteImport } from './routes/invitations.$token'
import { Route as DemosComponentShowcaseRouteImport } from './routes/demos/component-showcase'
import { Route as DealsStateIdRouteImport } from './routes/deals_.$stateId'
import { Route as CoachingSessionsRouteImport } from './routes/coaching/sessions'
import { Route as CoachingNotesRouteImport } from './routes/coaching/notes'
import { Route as AnalyticsVoiceRouteImport } from './routes/analytics/voice'
import { Route as AnalyticsScriptStepsRouteImport } from './routes/analytics/script-steps'
import { Route as AnalyticsObjectionsRouteImport } from './routes/analytics/objections'
import { Route as AnalyticsMissedCallsRouteImport } from './routes/analytics/missed-calls'
import { Route as AnalyticsCustomerQuestionsRouteImport } from './routes/analytics/customer-questions'
import { Route as AnalyticsCriteriaRouteImport } from './routes/analytics/criteria'
import { Route as AnalyticsCallStatsRouteImport } from './routes/analytics/call-stats'
import { Route as AnalyticsBillingRouteImport } from './routes/analytics/billing'
import { Route as AnalyticsAiTasksRouteImport } from './routes/analytics/ai-tasks'
import { Route as AnalyticsAiFeedbackRouteImport } from './routes/analytics/ai-feedback'
import { Route as AnalysisSetupScriptsRouteImport } from './routes/analysis-setup.scripts'
import { Route as AnalysisSetupSalesMethodologyRouteImport } from './routes/analysis-setup.sales-methodology'
import { Route as AnalysisSetupRoutingRouteImport } from './routes/analysis-setup.routing'
import { Route as AnalysisSetupCrmUpdatesRouteImport } from './routes/analysis-setup.crm-updates'
import { Route as AnalysisSetupCriteriaRouteImport } from './routes/analysis-setup.criteria'
import { Route as AnalysisSetupCategoriesRouteImport } from './routes/analysis-setup.categories'
import { Route as AnalysisSetupCallCriteriaRouteImport } from './routes/analysis-setup.call-criteria'
import { Route as AgentsAgentIdRouteImport } from './routes/agents_.$agentId'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminPricingRouteImport } from './routes/admin/pricing'
import { Route as AdminPlatformDefaultsRouteImport } from './routes/admin/platform-defaults'
import { Route as AdminHealthRouteImport } from './routes/admin/health'
import { Route as AdminGlobalApiKeysRouteImport } from './routes/admin/global-api-keys'
import { Route as AdminFeatureFlagsRouteImport } from './routes/admin/feature-flags'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminCreditsRouteImport } from './routes/admin/credits'
import { Route as AdminApiKeysRouteImport } from './routes/admin/api-keys'
import { Route as EmbeddedDashboardIndexRouteImport } from './routes/embedded/dashboard/index'
import { Route as EmbeddedCrmTabIndexRouteImport } from './routes/embedded/crm-tab/index'
import { Route as IntegrationsUspacyLinkRouteImport } from './routes/integrations.uspacy.link'
import { Route as IntegrationsUspacyEmployeeLinkRouteImport } from './routes/integrations.uspacy.employee-link'
import { Route as ProjectsProjectIdSettingsIndexRouteImport } from './routes/projects.$projectId.settings/index'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const ScriptsRoute = ScriptsRouteImport.update({
  id: '/scripts',
  path: '/scripts',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewQueueRoute = ReviewQueueRouteImport.update({
  id: '/review-queue',
  path: '/review-queue',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordsRoute = RecordsRouteImport.update({
  id: '/records',
  path: '/records',
  getParentRoute: () => rootRouteImport,
} as any)
const PromptBuilderRoute = PromptBuilderRouteImport.update({
  id: '/prompt-builder',
  path: '/prompt-builder',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const LinkPortalRoute = LinkPortalRouteImport.update({
  id: '/link-portal',
  path: '/link-portal',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeBaseRoute = KnowledgeBaseRouteImport.update({
  id: '/knowledge-base',
  path: '/knowledge-base',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbeddedRoute = EmbeddedRouteImport.update({
  id: '/embedded',
  path: '/embedded',
  getParentRoute: () => rootRouteImport,
} as any)
const DemosRoute = DemosRouteImport.update({
  id: '/demos',
  path: '/demos',
  getParentRoute: () => rootRouteImport,
} as any)
const DealsRoute = DealsRouteImport.update({
  id: '/deals',
  path: '/deals',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CompetitionsRoute = CompetitionsRouteImport.update({
  id: '/competitions',
  path: '/competitions',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AssistantRoute = AssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalysisSetupRoute = AnalysisSetupRouteImport.update({
  id: '/analysis-setup',
  path: '/analysis-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalysesRoute = AnalysesRouteImport.update({
  id: '/analyses',
  path: '/analyses',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertsRoute = AlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const DemosIndexRoute = DemosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemosRoute,
} as any)
const CoachingIndexRoute = CoachingIndexRouteImport.update({
  id: '/coaching/',
  path: '/coaching/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AnalyticsRoute,
} as any)
const AnalysisSetupIndexRoute = AnalysisSetupIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AnalysisSetupRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const ProjectsNewRoute = ProjectsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ProjectsRoute,
} as any)
const InvitationsTokenRoute = InvitationsTokenRouteImport.update({
  id: '/invitations/$token',
  path: '/invitations/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DemosComponentShowcaseRoute = DemosComponentShowcaseRouteImport.update({
  id: '/component-showcase',
  path: '/component-showcase',
  getParentRoute: () => DemosRoute,
} as any)
const DealsStateIdRoute = DealsStateIdRouteImport.update({
  id: '/deals_/$stateId',
  path: '/deals/$stateId',
  getParentRoute: () => rootRouteImport,
} as any)
const CoachingSessionsRoute = CoachingSessionsRouteImport.update({
  id: '/coaching/sessions',
  path: '/coaching/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const CoachingNotesRoute = CoachingNotesRouteImport.update({
  id: '/coaching/notes',
  path: '/coaching/notes',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsVoiceRoute = AnalyticsVoiceRouteImport.update({
  id: '/voice',
  path: '/voice',
  getParentRoute: () => AnalyticsRoute,
} as any)
const AnalyticsScriptStepsRoute = AnalyticsScriptStepsRouteImport.update({
  id: '/script-steps',
  path: '/script-steps',
  getParentRoute: () => AnalyticsRoute,
} as any)
const AnalyticsObjectionsRoute = AnalyticsObjectionsRouteImport.update({
  id: '/objections',
  path: '/objections',
  getParentRoute: () => AnalyticsRoute,
} as any)
const AnalyticsMissedCallsRoute = AnalyticsMissedCallsRouteImport.update({
  id: '/missed-calls',
  path: '/missed-calls',
  getParentRoute: () => AnalyticsRoute,
} as any)
const AnalyticsCustomerQuestionsRoute =
  AnalyticsCustomerQuestionsRouteImport.update({
    id: '/customer-questions',
    path: '/customer-questions',
    getParentRoute: () => AnalyticsRoute,
  } as any)
const AnalyticsCriteriaRoute = AnalyticsCriteriaRouteImport.update({
  id: '/criteria',
  path: '/criteria',
  getParentRoute: () => AnalyticsRoute,
} as any)
const AnalyticsCallStatsRoute = AnalyticsCallStatsRouteImport.update({
  id: '/call-stats',
  path: '/call-stats',
  getParentRoute: () => AnalyticsRoute,
} as any)
const AnalyticsBillingRoute = AnalyticsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AnalyticsRoute,
} as any)
const AnalyticsAiTasksRoute = AnalyticsAiTasksRouteImport.update({
  id: '/ai-tasks',
  path: '/ai-tasks',
  getParentRoute: () => AnalyticsRoute,
} as any)
const AnalyticsAiFeedbackRoute = AnalyticsAiFeedbackRouteImport.update({
  id: '/ai-feedback',
  path: '/ai-feedback',
  getParentRoute: () => AnalyticsRoute,
} as any)
const AnalysisSetupScriptsRoute = AnalysisSetupScriptsRouteImport.update({
  id: '/scripts',
  path: '/scripts',
  getParentRoute: () => AnalysisSetupRoute,
} as any)
const AnalysisSetupSalesMethodologyRoute =
  AnalysisSetupSalesMethodologyRouteImport.update({
    id: '/sales-methodology',
    path: '/sales-methodology',
    getParentRoute: () => AnalysisSetupRoute,
  } as any)
const AnalysisSetupRoutingRoute = AnalysisSetupRoutingRouteImport.update({
  id: '/routing',
  path: '/routing',
  getParentRoute: () => AnalysisSetupRoute,
} as any)
const AnalysisSetupCrmUpdatesRoute = AnalysisSetupCrmUpdatesRouteImport.update({
  id: '/crm-updates',
  path: '/crm-updates',
  getParentRoute: () => AnalysisSetupRoute,
} as any)
const AnalysisSetupCriteriaRoute = AnalysisSetupCriteriaRouteImport.update({
  id: '/criteria',
  path: '/criteria',
  getParentRoute: () => AnalysisSetupRoute,
} as any)
const AnalysisSetupCategoriesRoute = AnalysisSetupCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AnalysisSetupRoute,
} as any)
const AnalysisSetupCallCriteriaRoute =
  AnalysisSetupCallCriteriaRouteImport.update({
    id: '/call-criteria',
    path: '/call-criteria',
    getParentRoute: () => AnalysisSetupRoute,
  } as any)
const AgentsAgentIdRoute = AgentsAgentIdRouteImport.update({
  id: '/agents_/$agentId',
  path: '/agents/$agentId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPricingRoute = AdminPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPlatformDefaultsRoute = AdminPlatformDefaultsRouteImport.update({
  id: '/platform-defaults',
  path: '/platform-defaults',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHealthRoute = AdminHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGlobalApiKeysRoute = AdminGlobalApiKeysRouteImport.update({
  id: '/global-api-keys',
  path: '/global-api-keys',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeatureFlagsRoute = AdminFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCreditsRoute = AdminCreditsRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => AdminRoute,
} as any)
const AdminApiKeysRoute = AdminApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AdminRoute,
} as any)
const EmbeddedDashboardIndexRoute = EmbeddedDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => EmbeddedRoute,
} as any)
const EmbeddedCrmTabIndexRoute = EmbeddedCrmTabIndexRouteImport.update({
  id: '/crm-tab/',
  path: '/crm-tab/',
  getParentRoute: () => EmbeddedRoute,
} as any)
const IntegrationsUspacyLinkRoute = IntegrationsUspacyLinkRouteImport.update({
  id: '/integrations/uspacy/link',
  path: '/integrations/uspacy/link',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsUspacyEmployeeLinkRoute =
  IntegrationsUspacyEmployeeLinkRouteImport.update({
    id: '/integrations/uspacy/employee-link',
    path: '/integrations/uspacy/employee-link',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectsProjectIdSettingsIndexRoute =
  ProjectsProjectIdSettingsIndexRouteImport.update({
    id: '/$projectId/settings/',
    path: '/$projectId/settings/',
    getParentRoute: () => ProjectsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/alerts': typeof AlertsRoute
  '/analyses': typeof AnalysesRoute
  '/analysis-setup': typeof AnalysisSetupRouteWithChildren
  '/analytics': typeof AnalyticsRouteWithChildren
  '/assistant': typeof AssistantRoute
  '/billing': typeof BillingRoute
  '/competitions': typeof CompetitionsRoute
  '/dashboard': typeof DashboardRoute
  '/deals': typeof DealsRoute
  '/demos': typeof DemosRouteWithChildren
  '/embedded': typeof EmbeddedRouteWithChildren
  '/knowledge-base': typeof KnowledgeBaseRoute
  '/link-portal': typeof LinkPortalRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/prompt-builder': typeof PromptBuilderRoute
  '/records': typeof RecordsRoute
  '/review-queue': typeof ReviewQueueRoute
  '/scripts': typeof ScriptsRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/terms': typeof TermsRoute
  '/users': typeof UsersRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/credits': typeof AdminCreditsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/global-api-keys': typeof AdminGlobalApiKeysRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/platform-defaults': typeof AdminPlatformDefaultsRoute
  '/admin/pricing': typeof AdminPricingRoute
  '/admin/reports': typeof AdminReportsRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/analysis-setup/call-criteria': typeof AnalysisSetupCallCriteriaRoute
  '/analysis-setup/categories': typeof AnalysisSetupCategoriesRoute
  '/analysis-setup/criteria': typeof AnalysisSetupCriteriaRoute
  '/analysis-setup/crm-updates': typeof AnalysisSetupCrmUpdatesRoute
  '/analysis-setup/routing': typeof AnalysisSetupRoutingRoute
  '/analysis-setup/sales-methodology': typeof AnalysisSetupSalesMethodologyRoute
  '/analysis-setup/scripts': typeof AnalysisSetupScriptsRoute
  '/analytics/ai-feedback': typeof AnalyticsAiFeedbackRoute
  '/analytics/ai-tasks': typeof AnalyticsAiTasksRoute
  '/analytics/billing': typeof AnalyticsBillingRoute
  '/analytics/call-stats': typeof AnalyticsCallStatsRoute
  '/analytics/criteria': typeof AnalyticsCriteriaRoute
  '/analytics/customer-questions': typeof AnalyticsCustomerQuestionsRoute
  '/analytics/missed-calls': typeof AnalyticsMissedCallsRoute
  '/analytics/objections': typeof AnalyticsObjectionsRoute
  '/analytics/script-steps': typeof AnalyticsScriptStepsRoute
  '/analytics/voice': typeof AnalyticsVoiceRoute
  '/coaching/notes': typeof CoachingNotesRoute
  '/coaching/sessions': typeof CoachingSessionsRoute
  '/deals/$stateId': typeof DealsStateIdRoute
  '/demos/component-showcase': typeof DemosComponentShowcaseRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/projects/new': typeof ProjectsNewRoute
  '/admin/': typeof AdminIndexRoute
  '/analysis-setup/': typeof AnalysisSetupIndexRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/coaching/': typeof CoachingIndexRoute
  '/demos/': typeof DemosIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/integrations/uspacy/employee-link': typeof IntegrationsUspacyEmployeeLinkRoute
  '/integrations/uspacy/link': typeof IntegrationsUspacyLinkRoute
  '/embedded/crm-tab/': typeof EmbeddedCrmTabIndexRoute
  '/embedded/dashboard/': typeof EmbeddedDashboardIndexRoute
  '/projects/$projectId/settings/': typeof ProjectsProjectIdSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/alerts': typeof AlertsRoute
  '/analyses': typeof AnalysesRoute
  '/assistant': typeof AssistantRoute
  '/billing': typeof BillingRoute
  '/competitions': typeof CompetitionsRoute
  '/dashboard': typeof DashboardRoute
  '/deals': typeof DealsRoute
  '/embedded': typeof EmbeddedRouteWithChildren
  '/knowledge-base': typeof KnowledgeBaseRoute
  '/link-portal': typeof LinkPortalRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/prompt-builder': typeof PromptBuilderRoute
  '/records': typeof RecordsRoute
  '/review-queue': typeof ReviewQueueRoute
  '/scripts': typeof ScriptsRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/terms': typeof TermsRoute
  '/users': typeof UsersRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/credits': typeof AdminCreditsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/global-api-keys': typeof AdminGlobalApiKeysRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/platform-defaults': typeof AdminPlatformDefaultsRoute
  '/admin/pricing': typeof AdminPricingRoute
  '/admin/reports': typeof AdminReportsRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/analysis-setup/call-criteria': typeof AnalysisSetupCallCriteriaRoute
  '/analysis-setup/categories': typeof AnalysisSetupCategoriesRoute
  '/analysis-setup/criteria': typeof AnalysisSetupCriteriaRoute
  '/analysis-setup/crm-updates': typeof AnalysisSetupCrmUpdatesRoute
  '/analysis-setup/routing': typeof AnalysisSetupRoutingRoute
  '/analysis-setup/sales-methodology': typeof AnalysisSetupSalesMethodologyRoute
  '/analysis-setup/scripts': typeof AnalysisSetupScriptsRoute
  '/analytics/ai-feedback': typeof AnalyticsAiFeedbackRoute
  '/analytics/ai-tasks': typeof AnalyticsAiTasksRoute
  '/analytics/billing': typeof AnalyticsBillingRoute
  '/analytics/call-stats': typeof AnalyticsCallStatsRoute
  '/analytics/criteria': typeof AnalyticsCriteriaRoute
  '/analytics/customer-questions': typeof AnalyticsCustomerQuestionsRoute
  '/analytics/missed-calls': typeof AnalyticsMissedCallsRoute
  '/analytics/objections': typeof AnalyticsObjectionsRoute
  '/analytics/script-steps': typeof AnalyticsScriptStepsRoute
  '/analytics/voice': typeof AnalyticsVoiceRoute
  '/coaching/notes': typeof CoachingNotesRoute
  '/coaching/sessions': typeof CoachingSessionsRoute
  '/deals/$stateId': typeof DealsStateIdRoute
  '/demos/component-showcase': typeof DemosComponentShowcaseRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/projects/new': typeof ProjectsNewRoute
  '/admin': typeof AdminIndexRoute
  '/analysis-setup': typeof AnalysisSetupIndexRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/coaching': typeof CoachingIndexRoute
  '/demos': typeof DemosIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/integrations/uspacy/employee-link': typeof IntegrationsUspacyEmployeeLinkRoute
  '/integrations/uspacy/link': typeof IntegrationsUspacyLinkRoute
  '/embedded/crm-tab': typeof EmbeddedCrmTabIndexRoute
  '/embedded/dashboard': typeof EmbeddedDashboardIndexRoute
  '/projects/$projectId/settings': typeof ProjectsProjectIdSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/alerts': typeof AlertsRoute
  '/analyses': typeof AnalysesRoute
  '/analysis-setup': typeof AnalysisSetupRouteWithChildren
  '/analytics': typeof AnalyticsRouteWithChildren
  '/assistant': typeof AssistantRoute
  '/billing': typeof BillingRoute
  '/competitions': typeof CompetitionsRoute
  '/dashboard': typeof DashboardRoute
  '/deals': typeof DealsRoute
  '/demos': typeof DemosRouteWithChildren
  '/embedded': typeof EmbeddedRouteWithChildren
  '/knowledge-base': typeof KnowledgeBaseRoute
  '/link-portal': typeof LinkPortalRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/prompt-builder': typeof PromptBuilderRoute
  '/records': typeof RecordsRoute
  '/review-queue': typeof ReviewQueueRoute
  '/scripts': typeof ScriptsRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/terms': typeof TermsRoute
  '/users': typeof UsersRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/credits': typeof AdminCreditsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/global-api-keys': typeof AdminGlobalApiKeysRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/platform-defaults': typeof AdminPlatformDefaultsRoute
  '/admin/pricing': typeof AdminPricingRoute
  '/admin/reports': typeof AdminReportsRoute
  '/agents_/$agentId': typeof AgentsAgentIdRoute
  '/analysis-setup/call-criteria': typeof AnalysisSetupCallCriteriaRoute
  '/analysis-setup/categories': typeof AnalysisSetupCategoriesRoute
  '/analysis-setup/criteria': typeof AnalysisSetupCriteriaRoute
  '/analysis-setup/crm-updates': typeof AnalysisSetupCrmUpdatesRoute
  '/analysis-setup/routing': typeof AnalysisSetupRoutingRoute
  '/analysis-setup/sales-methodology': typeof AnalysisSetupSalesMethodologyRoute
  '/analysis-setup/scripts': typeof AnalysisSetupScriptsRoute
  '/analytics/ai-feedback': typeof AnalyticsAiFeedbackRoute
  '/analytics/ai-tasks': typeof AnalyticsAiTasksRoute
  '/analytics/billing': typeof AnalyticsBillingRoute
  '/analytics/call-stats': typeof AnalyticsCallStatsRoute
  '/analytics/criteria': typeof AnalyticsCriteriaRoute
  '/analytics/customer-questions': typeof AnalyticsCustomerQuestionsRoute
  '/analytics/missed-calls': typeof AnalyticsMissedCallsRoute
  '/analytics/objections': typeof AnalyticsObjectionsRoute
  '/analytics/script-steps': typeof AnalyticsScriptStepsRoute
  '/analytics/voice': typeof AnalyticsVoiceRoute
  '/coaching/notes': typeof CoachingNotesRoute
  '/coaching/sessions': typeof CoachingSessionsRoute
  '/deals_/$stateId': typeof DealsStateIdRoute
  '/demos/component-showcase': typeof DemosComponentShowcaseRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/projects/new': typeof ProjectsNewRoute
  '/admin/': typeof AdminIndexRoute
  '/analysis-setup/': typeof AnalysisSetupIndexRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/coaching/': typeof CoachingIndexRoute
  '/demos/': typeof DemosIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/integrations/uspacy/employee-link': typeof IntegrationsUspacyEmployeeLinkRoute
  '/integrations/uspacy/link': typeof IntegrationsUspacyLinkRoute
  '/embedded/crm-tab/': typeof EmbeddedCrmTabIndexRoute
  '/embedded/dashboard/': typeof EmbeddedDashboardIndexRoute
  '/projects/$projectId/settings/': typeof ProjectsProjectIdSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/alerts'
    | '/analyses'
    | '/analysis-setup'
    | '/analytics'
    | '/assistant'
    | '/billing'
    | '/competitions'
    | '/dashboard'
    | '/deals'
    | '/demos'
    | '/embedded'
    | '/knowledge-base'
    | '/link-portal'
    | '/notifications'
    | '/onboarding'
    | '/privacy'
    | '/projects'
    | '/prompt-builder'
    | '/records'
    | '/review-queue'
    | '/scripts'
    | '/sign-in'
    | '/sign-up'
    | '/terms'
    | '/users'
    | '/admin/api-keys'
    | '/admin/credits'
    | '/admin/dashboard'
    | '/admin/feature-flags'
    | '/admin/global-api-keys'
    | '/admin/health'
    | '/admin/platform-defaults'
    | '/admin/pricing'
    | '/admin/reports'
    | '/agents/$agentId'
    | '/analysis-setup/call-criteria'
    | '/analysis-setup/categories'
    | '/analysis-setup/criteria'
    | '/analysis-setup/crm-updates'
    | '/analysis-setup/routing'
    | '/analysis-setup/sales-methodology'
    | '/analysis-setup/scripts'
    | '/analytics/ai-feedback'
    | '/analytics/ai-tasks'
    | '/analytics/billing'
    | '/analytics/call-stats'
    | '/analytics/criteria'
    | '/analytics/customer-questions'
    | '/analytics/missed-calls'
    | '/analytics/objections'
    | '/analytics/script-steps'
    | '/analytics/voice'
    | '/coaching/notes'
    | '/coaching/sessions'
    | '/deals/$stateId'
    | '/demos/component-showcase'
    | '/invitations/$token'
    | '/projects/new'
    | '/admin/'
    | '/analysis-setup/'
    | '/analytics/'
    | '/coaching/'
    | '/demos/'
    | '/settings/'
    | '/integrations/uspacy/employee-link'
    | '/integrations/uspacy/link'
    | '/embedded/crm-tab/'
    | '/embedded/dashboard/'
    | '/projects/$projectId/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/alerts'
    | '/analyses'
    | '/assistant'
    | '/billing'
    | '/competitions'
    | '/dashboard'
    | '/deals'
    | '/embedded'
    | '/knowledge-base'
    | '/link-portal'
    | '/notifications'
    | '/onboarding'
    | '/privacy'
    | '/projects'
    | '/prompt-builder'
    | '/records'
    | '/review-queue'
    | '/scripts'
    | '/sign-in'
    | '/sign-up'
    | '/terms'
    | '/users'
    | '/admin/api-keys'
    | '/admin/credits'
    | '/admin/dashboard'
    | '/admin/feature-flags'
    | '/admin/global-api-keys'
    | '/admin/health'
    | '/admin/platform-defaults'
    | '/admin/pricing'
    | '/admin/reports'
    | '/agents/$agentId'
    | '/analysis-setup/call-criteria'
    | '/analysis-setup/categories'
    | '/analysis-setup/criteria'
    | '/analysis-setup/crm-updates'
    | '/analysis-setup/routing'
    | '/analysis-setup/sales-methodology'
    | '/analysis-setup/scripts'
    | '/analytics/ai-feedback'
    | '/analytics/ai-tasks'
    | '/analytics/billing'
    | '/analytics/call-stats'
    | '/analytics/criteria'
    | '/analytics/customer-questions'
    | '/analytics/missed-calls'
    | '/analytics/objections'
    | '/analytics/script-steps'
    | '/analytics/voice'
    | '/coaching/notes'
    | '/coaching/sessions'
    | '/deals/$stateId'
    | '/demos/component-showcase'
    | '/invitations/$token'
    | '/projects/new'
    | '/admin'
    | '/analysis-setup'
    | '/analytics'
    | '/coaching'
    | '/demos'
    | '/settings'
    | '/integrations/uspacy/employee-link'
    | '/integrations/uspacy/link'
    | '/embedded/crm-tab'
    | '/embedded/dashboard'
    | '/projects/$projectId/settings'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/alerts'
    | '/analyses'
    | '/analysis-setup'
    | '/analytics'
    | '/assistant'
    | '/billing'
    | '/competitions'
    | '/dashboard'
    | '/deals'
    | '/demos'
    | '/embedded'
    | '/knowledge-base'
    | '/link-portal'
    | '/notifications'
    | '/onboarding'
    | '/privacy'
    | '/projects'
    | '/prompt-builder'
    | '/records'
    | '/review-queue'
    | '/scripts'
    | '/sign-in'
    | '/sign-up'
    | '/terms'
    | '/users'
    | '/admin/api-keys'
    | '/admin/credits'
    | '/admin/dashboard'
    | '/admin/feature-flags'
    | '/admin/global-api-keys'
    | '/admin/health'
    | '/admin/platform-defaults'
    | '/admin/pricing'
    | '/admin/reports'
    | '/agents_/$agentId'
    | '/analysis-setup/call-criteria'
    | '/analysis-setup/categories'
    | '/analysis-setup/criteria'
    | '/analysis-setup/crm-updates'
    | '/analysis-setup/routing'
    | '/analysis-setup/sales-methodology'
    | '/analysis-setup/scripts'
    | '/analytics/ai-feedback'
    | '/analytics/ai-tasks'
    | '/analytics/billing'
    | '/analytics/call-stats'
    | '/analytics/criteria'
    | '/analytics/customer-questions'
    | '/analytics/missed-calls'
    | '/analytics/objections'
    | '/analytics/script-steps'
    | '/analytics/voice'
    | '/coaching/notes'
    | '/coaching/sessions'
    | '/deals_/$stateId'
    | '/demos/component-showcase'
    | '/invitations/$token'
    | '/projects/new'
    | '/admin/'
    | '/analysis-setup/'
    | '/analytics/'
    | '/coaching/'
    | '/demos/'
    | '/settings/'
    | '/integrations/uspacy/employee-link'
    | '/integrations/uspacy/link'
    | '/embedded/crm-tab/'
    | '/embedded/dashboard/'
    | '/projects/$projectId/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AlertsRoute: typeof AlertsRoute
  AnalysesRoute: typeof AnalysesRoute
  AnalysisSetupRoute: typeof AnalysisSetupRouteWithChildren
  AnalyticsRoute: typeof AnalyticsRouteWithChildren
  AssistantRoute: typeof AssistantRoute
  BillingRoute: typeof BillingRoute
  CompetitionsRoute: typeof CompetitionsRoute
  DashboardRoute: typeof DashboardRoute
  DealsRoute: typeof DealsRoute
  DemosRoute: typeof DemosRouteWithChildren
  EmbeddedRoute: typeof EmbeddedRouteWithChildren
  KnowledgeBaseRoute: typeof KnowledgeBaseRoute
  LinkPortalRoute: typeof LinkPortalRoute
  NotificationsRoute: typeof NotificationsRoute
  OnboardingRoute: typeof OnboardingRoute
  PrivacyRoute: typeof PrivacyRoute
  ProjectsRoute: typeof ProjectsRouteWithChildren
  PromptBuilderRoute: typeof PromptBuilderRoute
  RecordsRoute: typeof RecordsRoute
  ReviewQueueRoute: typeof ReviewQueueRoute
  ScriptsRoute: typeof ScriptsRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  TermsRoute: typeof TermsRoute
  UsersRoute: typeof UsersRoute
  AgentsAgentIdRoute: typeof AgentsAgentIdRoute
  CoachingNotesRoute: typeof CoachingNotesRoute
  CoachingSessionsRoute: typeof CoachingSessionsRoute
  DealsStateIdRoute: typeof DealsStateIdRoute
  InvitationsTokenRoute: typeof InvitationsTokenRoute
  CoachingIndexRoute: typeof CoachingIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  IntegrationsUspacyEmployeeLinkRoute: typeof IntegrationsUspacyEmployeeLinkRoute
  IntegrationsUspacyLinkRoute: typeof IntegrationsUspacyLinkRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scripts': {
      id: '/scripts'
      path: '/scripts'
      fullPath: '/scripts'
      preLoaderRoute: typeof ScriptsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review-queue': {
      id: '/review-queue'
      path: '/review-queue'
      fullPath: '/review-queue'
      preLoaderRoute: typeof ReviewQueueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/records': {
      id: '/records'
      path: '/records'
      fullPath: '/records'
      preLoaderRoute: typeof RecordsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prompt-builder': {
      id: '/prompt-builder'
      path: '/prompt-builder'
      fullPath: '/prompt-builder'
      preLoaderRoute: typeof PromptBuilderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/link-portal': {
      id: '/link-portal'
      path: '/link-portal'
      fullPath: '/link-portal'
      preLoaderRoute: typeof LinkPortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge-base': {
      id: '/knowledge-base'
      path: '/knowledge-base'
      fullPath: '/knowledge-base'
      preLoaderRoute: typeof KnowledgeBaseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embedded': {
      id: '/embedded'
      path: '/embedded'
      fullPath: '/embedded'
      preLoaderRoute: typeof EmbeddedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demos': {
      id: '/demos'
      path: '/demos'
      fullPath: '/demos'
      preLoaderRoute: typeof DemosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deals': {
      id: '/deals'
      path: '/deals'
      fullPath: '/deals'
      preLoaderRoute: typeof DealsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/competitions': {
      id: '/competitions'
      path: '/competitions'
      fullPath: '/competitions'
      preLoaderRoute: typeof CompetitionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assistant': {
      id: '/assistant'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof AssistantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analysis-setup': {
      id: '/analysis-setup'
      path: '/analysis-setup'
      fullPath: '/analysis-setup'
      preLoaderRoute: typeof AnalysisSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analyses': {
      id: '/analyses'
      path: '/analyses'
      fullPath: '/analyses'
      preLoaderRoute: typeof AnalysesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerts': {
      id: '/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AlertsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demos/': {
      id: '/demos/'
      path: '/'
      fullPath: '/demos/'
      preLoaderRoute: typeof DemosIndexRouteImport
      parentRoute: typeof DemosRoute
    }
    '/coaching/': {
      id: '/coaching/'
      path: '/coaching'
      fullPath: '/coaching/'
      preLoaderRoute: typeof CoachingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AnalyticsIndexRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/analysis-setup/': {
      id: '/analysis-setup/'
      path: '/'
      fullPath: '/analysis-setup/'
      preLoaderRoute: typeof AnalysisSetupIndexRouteImport
      parentRoute: typeof AnalysisSetupRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/projects/new': {
      id: '/projects/new'
      path: '/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/invitations/$token': {
      id: '/invitations/$token'
      path: '/invitations/$token'
      fullPath: '/invitations/$token'
      preLoaderRoute: typeof InvitationsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demos/component-showcase': {
      id: '/demos/component-showcase'
      path: '/component-showcase'
      fullPath: '/demos/component-showcase'
      preLoaderRoute: typeof DemosComponentShowcaseRouteImport
      parentRoute: typeof DemosRoute
    }
    '/deals_/$stateId': {
      id: '/deals_/$stateId'
      path: '/deals/$stateId'
      fullPath: '/deals/$stateId'
      preLoaderRoute: typeof DealsStateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coaching/sessions': {
      id: '/coaching/sessions'
      path: '/coaching/sessions'
      fullPath: '/coaching/sessions'
      preLoaderRoute: typeof CoachingSessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coaching/notes': {
      id: '/coaching/notes'
      path: '/coaching/notes'
      fullPath: '/coaching/notes'
      preLoaderRoute: typeof CoachingNotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/voice': {
      id: '/analytics/voice'
      path: '/voice'
      fullPath: '/analytics/voice'
      preLoaderRoute: typeof AnalyticsVoiceRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/analytics/script-steps': {
      id: '/analytics/script-steps'
      path: '/script-steps'
      fullPath: '/analytics/script-steps'
      preLoaderRoute: typeof AnalyticsScriptStepsRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/analytics/objections': {
      id: '/analytics/objections'
      path: '/objections'
      fullPath: '/analytics/objections'
      preLoaderRoute: typeof AnalyticsObjectionsRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/analytics/missed-calls': {
      id: '/analytics/missed-calls'
      path: '/missed-calls'
      fullPath: '/analytics/missed-calls'
      preLoaderRoute: typeof AnalyticsMissedCallsRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/analytics/customer-questions': {
      id: '/analytics/customer-questions'
      path: '/customer-questions'
      fullPath: '/analytics/customer-questions'
      preLoaderRoute: typeof AnalyticsCustomerQuestionsRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/analytics/criteria': {
      id: '/analytics/criteria'
      path: '/criteria'
      fullPath: '/analytics/criteria'
      preLoaderRoute: typeof AnalyticsCriteriaRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/analytics/call-stats': {
      id: '/analytics/call-stats'
      path: '/call-stats'
      fullPath: '/analytics/call-stats'
      preLoaderRoute: typeof AnalyticsCallStatsRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/analytics/billing': {
      id: '/analytics/billing'
      path: '/billing'
      fullPath: '/analytics/billing'
      preLoaderRoute: typeof AnalyticsBillingRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/analytics/ai-tasks': {
      id: '/analytics/ai-tasks'
      path: '/ai-tasks'
      fullPath: '/analytics/ai-tasks'
      preLoaderRoute: typeof AnalyticsAiTasksRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/analytics/ai-feedback': {
      id: '/analytics/ai-feedback'
      path: '/ai-feedback'
      fullPath: '/analytics/ai-feedback'
      preLoaderRoute: typeof AnalyticsAiFeedbackRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/analysis-setup/scripts': {
      id: '/analysis-setup/scripts'
      path: '/scripts'
      fullPath: '/analysis-setup/scripts'
      preLoaderRoute: typeof AnalysisSetupScriptsRouteImport
      parentRoute: typeof AnalysisSetupRoute
    }
    '/analysis-setup/sales-methodology': {
      id: '/analysis-setup/sales-methodology'
      path: '/sales-methodology'
      fullPath: '/analysis-setup/sales-methodology'
      preLoaderRoute: typeof AnalysisSetupSalesMethodologyRouteImport
      parentRoute: typeof AnalysisSetupRoute
    }
    '/analysis-setup/routing': {
      id: '/analysis-setup/routing'
      path: '/routing'
      fullPath: '/analysis-setup/routing'
      preLoaderRoute: typeof AnalysisSetupRoutingRouteImport
      parentRoute: typeof AnalysisSetupRoute
    }
    '/analysis-setup/crm-updates': {
      id: '/analysis-setup/crm-updates'
      path: '/crm-updates'
      fullPath: '/analysis-setup/crm-updates'
      preLoaderRoute: typeof AnalysisSetupCrmUpdatesRouteImport
      parentRoute: typeof AnalysisSetupRoute
    }
    '/analysis-setup/criteria': {
      id: '/analysis-setup/criteria'
      path: '/criteria'
      fullPath: '/analysis-setup/criteria'
      preLoaderRoute: typeof AnalysisSetupCriteriaRouteImport
      parentRoute: typeof AnalysisSetupRoute
    }
    '/analysis-setup/categories': {
      id: '/analysis-setup/categories'
      path: '/categories'
      fullPath: '/analysis-setup/categories'
      preLoaderRoute: typeof AnalysisSetupCategoriesRouteImport
      parentRoute: typeof AnalysisSetupRoute
    }
    '/analysis-setup/call-criteria': {
      id: '/analysis-setup/call-criteria'
      path: '/call-criteria'
      fullPath: '/analysis-setup/call-criteria'
      preLoaderRoute: typeof AnalysisSetupCallCriteriaRouteImport
      parentRoute: typeof AnalysisSetupRoute
    }
    '/agents_/$agentId': {
      id: '/agents_/$agentId'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AgentsAgentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/pricing': {
      id: '/admin/pricing'
      path: '/pricing'
      fullPath: '/admin/pricing'
      preLoaderRoute: typeof AdminPricingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/platform-defaults': {
      id: '/admin/platform-defaults'
      path: '/platform-defaults'
      fullPath: '/admin/platform-defaults'
      preLoaderRoute: typeof AdminPlatformDefaultsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/health': {
      id: '/admin/health'
      path: '/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof AdminHealthRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/global-api-keys': {
      id: '/admin/global-api-keys'
      path: '/global-api-keys'
      fullPath: '/admin/global-api-keys'
      preLoaderRoute: typeof AdminGlobalApiKeysRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/feature-flags': {
      id: '/admin/feature-flags'
      path: '/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof AdminFeatureFlagsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/credits': {
      id: '/admin/credits'
      path: '/credits'
      fullPath: '/admin/credits'
      preLoaderRoute: typeof AdminCreditsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/api-keys': {
      id: '/admin/api-keys'
      path: '/api-keys'
      fullPath: '/admin/api-keys'
      preLoaderRoute: typeof AdminApiKeysRouteImport
      parentRoute: typeof AdminRoute
    }
    '/embedded/dashboard/': {
      id: '/embedded/dashboard/'
      path: '/dashboard'
      fullPath: '/embedded/dashboard/'
      preLoaderRoute: typeof EmbeddedDashboardIndexRouteImport
      parentRoute: typeof EmbeddedRoute
    }
    '/embedded/crm-tab/': {
      id: '/embedded/crm-tab/'
      path: '/crm-tab'
      fullPath: '/embedded/crm-tab/'
      preLoaderRoute: typeof EmbeddedCrmTabIndexRouteImport
      parentRoute: typeof EmbeddedRoute
    }
    '/integrations/uspacy/link': {
      id: '/integrations/uspacy/link'
      path: '/integrations/uspacy/link'
      fullPath: '/integrations/uspacy/link'
      preLoaderRoute: typeof IntegrationsUspacyLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/uspacy/employee-link': {
      id: '/integrations/uspacy/employee-link'
      path: '/integrations/uspacy/employee-link'
      fullPath: '/integrations/uspacy/employee-link'
      preLoaderRoute: typeof IntegrationsUspacyEmployeeLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/settings/': {
      id: '/projects/$projectId/settings/'
      path: '/$projectId/settings'
      fullPath: '/projects/$projectId/settings/'
      preLoaderRoute: typeof ProjectsProjectIdSettingsIndexRouteImport
      parentRoute: typeof ProjectsRoute
    }
  }
}

interface AdminRouteChildren {
  AdminApiKeysRoute: typeof AdminApiKeysRoute
  AdminCreditsRoute: typeof AdminCreditsRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminFeatureFlagsRoute: typeof AdminFeatureFlagsRoute
  AdminGlobalApiKeysRoute: typeof AdminGlobalApiKeysRoute
  AdminHealthRoute: typeof AdminHealthRoute
  AdminPlatformDefaultsRoute: typeof AdminPlatformDefaultsRoute
  AdminPricingRoute: typeof AdminPricingRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminApiKeysRoute: AdminApiKeysRoute,
  AdminCreditsRoute: AdminCreditsRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminFeatureFlagsRoute: AdminFeatureFlagsRoute,
  AdminGlobalApiKeysRoute: AdminGlobalApiKeysRoute,
  AdminHealthRoute: AdminHealthRoute,
  AdminPlatformDefaultsRoute: AdminPlatformDefaultsRoute,
  AdminPricingRoute: AdminPricingRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AnalysisSetupRouteChildren {
  AnalysisSetupCallCriteriaRoute: typeof AnalysisSetupCallCriteriaRoute
  AnalysisSetupCategoriesRoute: typeof AnalysisSetupCategoriesRoute
  AnalysisSetupCriteriaRoute: typeof AnalysisSetupCriteriaRoute
  AnalysisSetupCrmUpdatesRoute: typeof AnalysisSetupCrmUpdatesRoute
  AnalysisSetupRoutingRoute: typeof AnalysisSetupRoutingRoute
  AnalysisSetupSalesMethodologyRoute: typeof AnalysisSetupSalesMethodologyRoute
  AnalysisSetupScriptsRoute: typeof AnalysisSetupScriptsRoute
  AnalysisSetupIndexRoute: typeof AnalysisSetupIndexRoute
}

const AnalysisSetupRouteChildren: AnalysisSetupRouteChildren = {
  AnalysisSetupCallCriteriaRoute: AnalysisSetupCallCriteriaRoute,
  AnalysisSetupCategoriesRoute: AnalysisSetupCategoriesRoute,
  AnalysisSetupCriteriaRoute: AnalysisSetupCriteriaRoute,
  AnalysisSetupCrmUpdatesRoute: AnalysisSetupCrmUpdatesRoute,
  AnalysisSetupRoutingRoute: AnalysisSetupRoutingRoute,
  AnalysisSetupSalesMethodologyRoute: AnalysisSetupSalesMethodologyRoute,
  AnalysisSetupScriptsRoute: AnalysisSetupScriptsRoute,
  AnalysisSetupIndexRoute: AnalysisSetupIndexRoute,
}

const AnalysisSetupRouteWithChildren = AnalysisSetupRoute._addFileChildren(
  AnalysisSetupRouteChildren,
)

interface AnalyticsRouteChildren {
  AnalyticsAiFeedbackRoute: typeof AnalyticsAiFeedbackRoute
  AnalyticsAiTasksRoute: typeof AnalyticsAiTasksRoute
  AnalyticsBillingRoute: typeof AnalyticsBillingRoute
  AnalyticsCallStatsRoute: typeof AnalyticsCallStatsRoute
  AnalyticsCriteriaRoute: typeof AnalyticsCriteriaRoute
  AnalyticsCustomerQuestionsRoute: typeof AnalyticsCustomerQuestionsRoute
  AnalyticsMissedCallsRoute: typeof AnalyticsMissedCallsRoute
  AnalyticsObjectionsRoute: typeof AnalyticsObjectionsRoute
  AnalyticsScriptStepsRoute: typeof AnalyticsScriptStepsRoute
  AnalyticsVoiceRoute: typeof AnalyticsVoiceRoute
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
}

const AnalyticsRouteChildren: AnalyticsRouteChildren = {
  AnalyticsAiFeedbackRoute: AnalyticsAiFeedbackRoute,
  AnalyticsAiTasksRoute: AnalyticsAiTasksRoute,
  AnalyticsBillingRoute: AnalyticsBillingRoute,
  AnalyticsCallStatsRoute: AnalyticsCallStatsRoute,
  AnalyticsCriteriaRoute: AnalyticsCriteriaRoute,
  AnalyticsCustomerQuestionsRoute: AnalyticsCustomerQuestionsRoute,
  AnalyticsMissedCallsRoute: AnalyticsMissedCallsRoute,
  AnalyticsObjectionsRoute: AnalyticsObjectionsRoute,
  AnalyticsScriptStepsRoute: AnalyticsScriptStepsRoute,
  AnalyticsVoiceRoute: AnalyticsVoiceRoute,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
}

const AnalyticsRouteWithChildren = AnalyticsRoute._addFileChildren(
  AnalyticsRouteChildren,
)

interface DemosRouteChildren {
  DemosComponentShowcaseRoute: typeof DemosComponentShowcaseRoute
  DemosIndexRoute: typeof DemosIndexRoute
}

const DemosRouteChildren: DemosRouteChildren = {
  DemosComponentShowcaseRoute: DemosComponentShowcaseRoute,
  DemosIndexRoute: DemosIndexRoute,
}

const DemosRouteWithChildren = DemosRoute._addFileChildren(DemosRouteChildren)

interface EmbeddedRouteChildren {
  EmbeddedCrmTabIndexRoute: typeof EmbeddedCrmTabIndexRoute
  EmbeddedDashboardIndexRoute: typeof EmbeddedDashboardIndexRoute
}

const EmbeddedRouteChildren: EmbeddedRouteChildren = {
  EmbeddedCrmTabIndexRoute: EmbeddedCrmTabIndexRoute,
  EmbeddedDashboardIndexRoute: EmbeddedDashboardIndexRoute,
}

const EmbeddedRouteWithChildren = EmbeddedRoute._addFileChildren(
  EmbeddedRouteChildren,
)

interface ProjectsRouteChildren {
  ProjectsNewRoute: typeof ProjectsNewRoute
  ProjectsProjectIdSettingsIndexRoute: typeof ProjectsProjectIdSettingsIndexRoute
}

const ProjectsRouteChildren: ProjectsRouteChildren = {
  ProjectsNewRoute: ProjectsNewRoute,
  ProjectsProjectIdSettingsIndexRoute: ProjectsProjectIdSettingsIndexRoute,
}

const ProjectsRouteWithChildren = ProjectsRoute._addFileChildren(
  ProjectsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AlertsRoute: AlertsRoute,
  AnalysesRoute: AnalysesRoute,
  AnalysisSetupRoute: AnalysisSetupRouteWithChildren,
  AnalyticsRoute: AnalyticsRouteWithChildren,
  AssistantRoute: AssistantRoute,
  BillingRoute: BillingRoute,
  CompetitionsRoute: CompetitionsRoute,
  DashboardRoute: DashboardRoute,
  DealsRoute: DealsRoute,
  DemosRoute: DemosRouteWithChildren,
  EmbeddedRoute: EmbeddedRouteWithChildren,
  KnowledgeBaseRoute: KnowledgeBaseRoute,
  LinkPortalRoute: LinkPortalRoute,
  NotificationsRoute: NotificationsRoute,
  OnboardingRoute: OnboardingRoute,
  PrivacyRoute: PrivacyRoute,
  ProjectsRoute: ProjectsRouteWithChildren,
  PromptBuilderRoute: PromptBuilderRoute,
  RecordsRoute: RecordsRoute,
  ReviewQueueRoute: ReviewQueueRoute,
  ScriptsRoute: ScriptsRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  TermsRoute: TermsRoute,
  UsersRoute: UsersRoute,
  AgentsAgentIdRoute: AgentsAgentIdRoute,
  CoachingNotesRoute: CoachingNotesRoute,
  CoachingSessionsRoute: CoachingSessionsRoute,
  DealsStateIdRoute: DealsStateIdRoute,
  InvitationsTokenRoute: InvitationsTokenRoute,
  CoachingIndexRoute: CoachingIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  IntegrationsUspacyEmployeeLinkRoute: IntegrationsUspacyEmployeeLinkRoute,
  IntegrationsUspacyLinkRoute: IntegrationsUspacyLinkRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
